<template>
  <div class="quiz-item">
    <div class="row">
      <div class="col-md-12">
        <div class="title">{{data.Question}}</div>

        <div class="answers">
          <radio name="robot" v-model='radio' :value="answer.key" class="answer" v-for="answer in data.Answers" v-bind:key="answer.answer">
            {{answer.answer}}
          </radio>
        </div>

        <div class="text-center">
          <div class="be-you-btn be-you-btn-narrow" v-on:click="next()" v-bind:class="{disabled: btnDisabled}">
            Ďalej
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      radio: ''
    }
  },
  props: [
    'data'
  ],
  computed: {
    btnDisabled () {
      if (this.radio.length) {
        return false
      }
      return true
    }
  },
  components: {
  },
  methods: {
    next: function (event) {
      if (this.radio.length) {
        this.$emit('next', this.radio)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .quiz-item {
    .title {
      font-size: 30px;
      font-weight: 700;
      text-align: center;
    }
    .answers {
      padding: 50px 0 30px 0;
      .answer {
        font-size: 23px;
        display: inline-block;
        vertical-align: top;
        width: 100%;
        padding-bottom: 25px;
        /deep/ label {
          margin-bottom: 0;
        }
        /*&:last-of-type {*/
          /*padding-bottom: 0;*/
        /*}*/
        @media (min-width: $breakpoint-md) {
          width: 50%;
          &:nth-of-type(odd) {
            padding-right: 40px;
          }
          &:nth-of-type(even) {
            padding-left: 40px;
          }
        }
        @media (min-width: $breakpoint-lg) {
          &:nth-of-type(odd) {
            padding-right: 40px;
            padding-left: 60px;
          }
          &:nth-of-type(even) {
            padding-left: 70px;
          }
        }
      }
    }

    @media (max-width: $breakpoint-md) {
      .title {
        padding-top: 40px;
      }
    }
    @media (max-width: $breakpoint-sm) {
      .answers {
        padding: 30px 0 15px 0;
        .answer {
          padding-bottom: 20px;
        }
      }
    }
  }
</style>

<style lang="scss">
  .quiz-item {
    .answers {
      .answer {
        label {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizItem.vue